import { DateTime } from "luxon";
// import { DateFilterValue } from "@/enums/date-filter-value";
import Vue from "vue";
// import { DropdownFilters } from "@/enums/dropdown-filters";

export const GraphStoreBus = new Vue();

export const graphs = {
    namespaced: true,
    state: () => ({
        layout: [null, null, null, null, null, null],
        initialized: false,
        //Below width and height values from graphs
        defaultGraphHeight: "170px", //Used in the Line and Bar Graph
        defaultCountryGraphHeight: "125px",
        defaultCountryGraphWidth: "15px",
        defaultAppsConvGraphWidth: "125px",
        defaultAppsConvGraphHeight: "40px",

        // Filter defaults
        filters: {
            startDate: DateTime.utc().minus({ days: 27 }).toString(),
            endDate: DateTime.utc(),
            timePeriod: "last28Days",
            agents: [],
            channels: [],
            tags: [],
            teams: [],
        },
    }),
    mutations: {
        setInitialized(state, initialized) {
            state.initialized = initialized;
        },
        addToLayout(state, { graph, position }) {
            const emptyIndex = state.layout.findIndex((graph) => graph == null);

            if (emptyIndex == -1 && position < 0) {
                state.layout.push(graph);
            } else if (position < 0) {
                state.layout.splice(emptyIndex, 1, graph);
            } else {
                state.layout.splice(position, 1, graph);
            }
        },
        removeFromLayout(state, position) {
            state.layout.splice(position, 1, null);
        },
        mutateDates(state, { startDate, endDate, timePeriod }) {
            state.filters.startDate = startDate;
            state.filters.endDate = endDate;
            state.filters.timePeriod = timePeriod;
        },
        mutateFilterDropdowns(state, { filterType, data }) {
            const filters = {
                ["Agents"]: "agents",
                ["Channels"]: "channels",
                ["Tags"]: "tags",
                ["Teams"]: "teams",
            };

            state.filters[filters[filterType]] = data;
        },
        applyFilters(state) {
            GraphStoreBus.$emit("filterUpdated", state.filters);
        },
    },
    actions: {
        addGraph({ commit }, { graph, position = -1 }) {
            commit("addToLayout", { graph, position });
        },
        removeGraph({ commit }, position) {
            commit("removeFromLayout", position);
        },
    },
};
